<div>
  <div class="eye-icon">
    <!-- <svg viewBox="0 0 18 18">
            <use href="#eye" />
        </svg> -->
  </div>
</div>
